// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressPopup.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import connect from 'share/enhancers/Izenda.Connect';
import actions from './Izenda.ImportProgressPopupAction';
import ImportProgressList from './Izenda.ImportProgressList';
import { observable, action } from 'mobx';
import Button from 'share/components/controls/Izenda.Button';
import { IMPORT_STATUS_REFRESH_INTERVAL } from 'logic/data/Izenda.ImportConstants';

@connect(actions)
export default class ImportProgressPopup extends Component {
  @observable importProgressList: Array<any> = [];
  @observable isImportProcessCompleted: boolean = false;
  @observable isClickCancelBefore: boolean = false;

  constructor(props: any) {
    super(props);
    const { importFiles } = this.props;
    this.importProgressList = this.props.convertToImportProgressList(importFiles);
  }

  componentDidMount() {
    this.getStatusInterval = setInterval(this.updateStatus, IMPORT_STATUS_REFRESH_INTERVAL);
  }

  /**
   * Update import status
   */
  @action
  updateStatus = (): void => {
    this.props.updateImportStatus(this.importProgressList).then(completed => {
      if (completed) {
        clearInterval(this.getStatusInterval);
        this.isImportProcessCompleted = true;
      }
    });
  };

  /**
   * On click cancel button
   */
  onClickCancel = (): void => {
    this.isClickCancelBefore = true;
    clearInterval(this.getStatusInterval);
    this.props.onCancelImport(this.importProgressList).then(() => {
      this.isImportProcessCompleted = true;
    });
  };

  /**
   * On click ok button
   */
  onClickOk = (): void => {
    this.props.onClosing(this.importProgressList);
  };

  componentWillUnmount() {
    clearInterval(this.getStatusInterval);
  }

  render() {
    const { localization } = this.props;

    return (
      <Popup visible type="none" autoClose={false}>
        <Popup.Header showCloseButton={false} title={localization.getText('IMPORT_PROGRESS_POPUP_TITLE')} />
        <Popup.Body>
          <ImportProgressList importProgressList={this.importProgressList} />
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton
            disabled={!this.isImportProcessCompleted}
            onClick={this.onClickOk}
            label={localization.getText('COMMON_LABEL_OK')}
          />
          <Popup.ConfirmationButton
            disabled={this.isClickCancelBefore || this.isImportProcessCompleted}
            onClick={this.onClickCancel}
            label={localization.getText('IMPORT_PROGRESS_POPUP_CANCEL_IMPORT')}
          />
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportProgressPopup.js